<template>
  <div class="row task-container">
    <div class="col-md-12">
      <table class="table table-striped task-table" :id="tableId">
        <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>{{ tableId === 'articleFeedback' ? 'Article' : 'Comment' }}</th>
          <th>Emoji</th>
          <th class="text-center">Created At</th>
          <th v-if="tab === 'resolved'">Resolved By</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row,index) in list" :key="index">
          <td>{{row.fullName}}</td>
          <td>{{row.email}}</td>
          <td v-if="tableId === 'articleFeedback'">
            <span v-if="row.type === 'article_suggestion'">
              <b>Suggestion:</b> {{row.comment || ''}}
            </span>
            <span v-else-if="row.type === 'article_feedback'">
              <b>Article on which feedback was provided:</b> {{row.article ? row.article.title : ''}}
            </span>
          </td>
          <td v-else>{{row.comment.length >15 ? `${row.comment.substring(0, 15)}...` : row.comment}}</td>
          <td>
            <vue-reaction-emoji v-if="row.emojiReaction" height="30px" width="30px" :is-active="true" :reaction="row.emojiReaction" />
          </td>
          <td class="text-center">
            {{row.createdAt | formatDate}} <br>
            <a v-if=" tableId === 'articleFeedback' && row.checkInBy" href="javascript:void(0)" class="fs-10 badge badge-danger mr-2 ml-5">Checked in by: {{row.checkInBy}}</a>
          </td>
          <td v-if="tab === 'resolved'">{{ row.resolvedBy || '' }}</td>
          <td>
            <button @click="openModal(row)" title="View Details" class="btn btn-primary btn-sm ml-2">
              <i class="fa fa-eye"></i>
            </button>
            <button v-if="tableId === 'articleFeedback' && !row.checkInBy" @click="checkin(row, index)" :loading="selectedIndex === index && action === 'checkin'" :disabled="selectedIndex === index && action === 'checkin'" class="btn btn-primary btn-sm ml-2">
              Checkin
            </button>
            <button v-if="tableId === 'activeFeedback' || (tableId === 'articleFeedback' && row.checkInBy)" @click="resolveButton(row, index)" :loading="selectedIndex === index" :disabled="selectedIndex === index" class="btn btn-primary btn-sm ml-2">
              Resolve
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { VueReactionEmoji } from 'vue-feedback-reaction';
export default {
  name: "index",
  components: {
    VueReactionEmoji
  },
  props: {
    tableId: {
      type: String
    },
    list: {
      type: Array
    },
    tab: {
      type: String,
      required: false,
      default: 'pending'
    }
  },
  data () {
    return {
      selectedIndex: null,
      action: ''
    }
  },
  methods: {
    checkin(row,index) {
      this.selectedIndex = index;
      this.action = 'checkin'
      this.$emit('checkin', {...row})
      this.selectedIndex = null
      this.action = ''
    },
    async resolveButton (row, index) {
      try {
        this.selectedIndex = index
        this.$emit('resolve', {...row})
      } catch (e) {
        console.log()
      } finally{
        this.selectedIndex = null
      }
    },
    openModal (data) {
      this.$emit('openDetailModal', data)
    }
  }
}
</script>

<style scoped>

</style>